import type { ReactNode } from 'react';
import { ListRecordNavigation } from 'src/components/common/ListRecordNavigation';
import { useTaskListNavigation } from './useTaskListNavigation';

/**
 * Previous/next for a task opened from a task list. Renders nothing when the
 * task was opened from somewhere else. `children` stay in the header either way.
 */
export function TaskListNavigation({
  taskId,
  children,
}: {
  taskId: string;
  children?: ReactNode;
}) {
  const navigation = useTaskListNavigation(taskId);
  if (!navigation) return children ?? null;
  return (
    <div className="flex items-center gap-2">
      <ListRecordNavigation
        subject="task"
        model={navigation.model}
        onOpen={navigation.open}
      />
      {children}
    </div>
  );
}
